import React from 'react';
import { Helmet } from 'react-helmet-async';
import PackagesThrill from './PackagesThrill';
import logo from '../assets/seo-logo.png';

const Proj1 = () => {
    return (
        <>
            <Helmet>
                {/* Basic SEO */}
                <title>Prapancha Pravasa – Premium Travel Packages & Tour Services</title>
                <meta
                    name="description"
                    content="Book amazing travel packages with Prapancha Pravasa. Discover exotic destinations, luxury accommodations, and unforgettable experiences. Trusted travel agency with 5-star reviews."
                />
                <meta
                    name="keywords"
                    content="travel packages, tour services, luxury travel, holiday packages, prapancha pravasa, travel agency, vacation planning, destination tours"
                />
                <meta name="author" content="Prapancha Pravasa" />
                <meta name="publisher" content="Prapancha Pravasa" />
                <link rel="canonical" href="https://www.prapanchapravasa.com/" />

                {/* Open Graph / Facebook */}
                <meta property="og:title" content="Prapancha Pravasa – Premium Travel Packages & Tour Services" />
                <meta
                    property="og:description"
                    content="Book amazing travel packages with Prapancha Pravasa. Discover exotic destinations, luxury accommodations, and unforgettable experiences. Trusted travel agency with 5-star reviews."
                />
                <meta property="og:image" content={logo} />
                <meta property="og:image:width" content="1200" />
                <meta property="og:image:height" content="630" />
                <meta property="og:image:alt" content="Prapancha Pravasa Travel Agency Logo" />
                <meta property="og:url" content="https://www.prapanchapravasa.com/" />
                <meta property="og:type" content="website" />
                <meta property="og:site_name" content="Prapancha Pravasa" />
                <meta property="og:locale" content="en_US" />

                {/* Twitter Card */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Prapancha Pravasa – Premium Travel Packages & Tour Services" />
                <meta
                    name="twitter:description"
                    content="Book amazing travel packages with Prapancha Pravasa. Discover exotic destinations, luxury accommodations, and unforgettable experiences. Trusted travel agency with 5-star reviews."
                />
                <meta name="twitter:image" content={logo} />
                <meta name="twitter:image:alt" content="Prapancha Pravasa Travel Agency Logo" />

                {/* JSON-LD Schema for Organization / Travel Agency */}
                <script type="application/ld+json">
                    {`
            {
              "@context": "https://schema.org",
              "@type": "TravelAgency",
              "name": "Prapancha Pravasa",
              "alternateName": "Prapancha Pravasa Travel",
              "url": "https://www.prapanchapravasa.com/",
              "logo": "https://www.prapanchapravasa.com/seo-logo.png",
              "image": "https://www.prapanchapravasa.com/seo-logo.png",
              "description": "Premium travel agency offering luxury travel packages, tour services, and unforgettable vacation experiences across exotic destinations.",
              "telephone": "+91-XXXXXXXXXX",
              "email": "info@prapanchapravasa.com",
              "address": {
                "@type": "PostalAddress",
                "addressCountry": "IN",
                "addressLocality": "India"
              },
              "sameAs": [
                "https://www.facebook.com/prapanchapravasa",
                "https://www.instagram.com/prapanchapravasa"
              ],
              "serviceType": [
                "Travel Packages",
                "Tour Services",
                "Holiday Planning",
                "Luxury Travel",
                "Destination Tours"
              ],
              "areaServed": "Worldwide"
            }
          `}
                </script>
            </Helmet>

            {/* Page content */}
            <div className="min-h-screen bg-custom-white">
                <PackagesThrill />
            </div>
        </>
    );
};

export default Proj1;
